export default {"src":"/uk/_next/static/media/cloud-green-tick.77d600f6.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};